import { request, setStoredToken, clearStoredToken } from './client';

/**
 * 用户登录
 * @param {Object} credentials - {username, password}
 */
export const login = async (credentials) => {
  const user = await request('/auth/login', {
    method: 'POST',
    body: credentials,
    skipAuth: true,
  });
  // 后端返回的是用户对象，token在user.token中
  if (user?.token) {
    setStoredToken(user.token);
  }
  return user;
};

/**
 * 用户注册
 * @param {Object} payload - 注册信息
 */
export const register = async (payload) => {
  return request('/auth/register', {
    method: 'POST',
    body: payload,
    skipAuth: true,
  });
};

/**
 * 发送验证码
 * @param {Object} params - {phone, codeType}
 * 注意：后端使用@RequestParam接收，POST请求会将参数放在URL查询字符串中
 */
export const sendVerifyCode = async ({ phone, codeType }) => {
  return request('/auth/send-code', {
    method: 'POST',
    params: { phone, codeType },
    skipAuth: true,
  });
};

/**
 * 获取当前用户信息
 */
export const fetchCurrentUser = async () => {
  return request('/auth/info', {
    method: 'GET',
  });
};

/**
 * 用户登出
 */
export const logout = async () => {
  try {
    await request('/auth/logout', {
      method: 'POST',
    });
  } finally {
    clearStoredToken();
  }
};
